<template>
  <b-container v-if="this.$root.token">
    <br>
    <h3>Scoring Events</h3>
    <br>
    <SurveyList/>
    <br>
  </b-container>
</template>

<script>
// @ is an alias to /src
import SurveyList from '@/components/SurveyList.vue';

export default {
  name: 'ScoringEvents',
  components: {
    SurveyList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ScoringEvents.vue